const makeEntityExpanded = (entities, entityId) =>
  entities.map(entity => ({
    ...entity,
    expanded: entity.id === entityId ? true : entity.expanded,
  }));

export default makeEntityExpanded;
